export default __webpack_public_path__ + "static/media/sorting.1367bcc2.svg";